import type { NextPage } from "next";
import { StaticHeader, StaticPage } from "@components/StaticPage";

const SUPPORT_TEXT = `The easiest way to talk to us is to email us at [support@glow.app](mailto:support@glow.app).
Please include your wallet public address (not secret key) and any other information that would help us help you.

Support is usually available within 15 minutes from 9am - 9pm Pacific Time 7 days of the week.
If you write to us, you’ll get a reply within a day.

Some reminders:

- We don’t have your recovery phrase and will never ask you for it.
- Never share your recovery phrase with anyone.

Stay safe out there!
`;

const Support: NextPage = () => {
  return (
    <StaticPage
      title="Support"
      path="/support"
      header={<StaticHeader title="Support" subtitle="We are here to help!" />}
      markdown={SUPPORT_TEXT}
    />
  );
};

export default Support;
